import Sailboat from "./components/Sailboat.vue";
import Other from "./components/Other.vue";
import Motorboat from "./components/Motorboat.vue";
import Buoy from "./components/Buoy.vue";

const icons = [
    {name:"Sailboat",icon:Sailboat},
    {name:"Motorboat",icon:Motorboat},
    {name:"Buoy",icon:Buoy},
    {name:"Other",icon:Other},

];


export {icons}